import { connect } from 'react-redux';
import { closeSideBar } from '../../../store/sidebar';
import ViewContact, { DispatchPropsType } from '../organisms/contacts/viewContact';

const mapDisptachToProps = {
	onClose: () => closeSideBar(),
};

export default connect<undefined, DispatchPropsType>(
	undefined,
	mapDisptachToProps
)(ViewContact);
